import _defineProperty from "/builds/code/ict-prod/ICT.FSBO.FrontEnd/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/builds/code/ict-prod/ICT.FSBO.FrontEnd/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/builds/code/ict-prod/ICT.FSBO.FrontEnd/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/code/ict-prod/ICT.FSBO.FrontEnd/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/code/ict-prod/ICT.FSBO.FrontEnd/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/code/ict-prod/ICT.FSBO.FrontEnd/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/code/ict-prod/ICT.FSBO.FrontEnd/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/builds/code/ict-prod/ICT.FSBO.FrontEnd/web/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
import { AbortError, HttpError, TimeoutError } from "./Errors";
import { HttpClient, HttpResponse } from "./HttpClient";
import { LogLevel } from "./ILogger";
import { Platform, getGlobalThis } from "./Utils";
export var FetchHttpClient = /*#__PURE__*/function (_HttpClient) {
  _inherits(FetchHttpClient, _HttpClient);
  var _super = _createSuper(FetchHttpClient);
  function FetchHttpClient(logger) {
    var _this;
    _classCallCheck(this, FetchHttpClient);
    _this = _super.call(this);
    _this._logger = logger;
    if (typeof fetch === "undefined") {
      // In order to ignore the dynamic require in webpack builds we need to do this magic
      // @ts-ignore: TS doesn't know about these names
      var requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : require;
      // Cookies aren't automatically handled in Node so we need to add a CookieJar to preserve cookies across requests
      _this._jar = new (requireFunc("tough-cookie").CookieJar)();
      _this._fetchType = requireFunc("node-fetch");
      // node-fetch doesn't have a nice API for getting and setting cookies
      // fetch-cookie will wrap a fetch implementation with a default CookieJar or a provided one
      _this._fetchType = requireFunc("fetch-cookie")(_this._fetchType, _this._jar);
    } else {
      _this._fetchType = fetch.bind(getGlobalThis());
    }
    if (typeof AbortController === "undefined") {
      // In order to ignore the dynamic require in webpack builds we need to do this magic
      // @ts-ignore: TS doesn't know about these names
      var _requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : require;
      // Node needs EventListener methods on AbortController which our custom polyfill doesn't provide
      _this._abortControllerType = _requireFunc("abort-controller");
    } else {
      _this._abortControllerType = AbortController;
    }
    return _this;
  }
  /** @inheritDoc */
  _createClass(FetchHttpClient, [{
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        var _this2 = this;
        var abortController, error, timeoutId, msTimeout, response, errorMessage, content, payload;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(request.abortSignal && request.abortSignal.aborted)) {
                _context.next = 2;
                break;
              }
              throw new AbortError();
            case 2:
              if (request.method) {
                _context.next = 4;
                break;
              }
              throw new Error("No method defined.");
            case 4:
              if (request.url) {
                _context.next = 6;
                break;
              }
              throw new Error("No url defined.");
            case 6:
              abortController = new this._abortControllerType();
              // Hook our abortSignal into the abort controller
              if (request.abortSignal) {
                request.abortSignal.onabort = function () {
                  abortController.abort();
                  error = new AbortError();
                };
              }
              // If a timeout has been passed in, setup a timeout to call abort
              // Type needs to be any to fit window.setTimeout and NodeJS.setTimeout
              timeoutId = null;
              if (request.timeout) {
                msTimeout = request.timeout;
                timeoutId = setTimeout(function () {
                  abortController.abort();
                  _this2._logger.log(LogLevel.Warning, "Timeout from HTTP request.");
                  error = new TimeoutError();
                }, msTimeout);
              }
              _context.prev = 10;
              _context.next = 13;
              return this._fetchType(request.url, {
                body: request.content,
                cache: "no-cache",
                credentials: request.withCredentials === true ? "include" : "same-origin",
                headers: _objectSpread({
                  "Content-Type": "text/plain;charset=UTF-8",
                  "X-Requested-With": "XMLHttpRequest"
                }, request.headers),
                method: request.method,
                mode: "cors",
                redirect: "follow",
                signal: abortController.signal
              });
            case 13:
              response = _context.sent;
              _context.next = 22;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](10);
              if (!error) {
                _context.next = 20;
                break;
              }
              throw error;
            case 20:
              this._logger.log(LogLevel.Warning, "Error from HTTP request. ".concat(_context.t0, "."));
              throw _context.t0;
            case 22:
              _context.prev = 22;
              if (timeoutId) {
                clearTimeout(timeoutId);
              }
              if (request.abortSignal) {
                request.abortSignal.onabort = null;
              }
              return _context.finish(22);
            case 26:
              if (response.ok) {
                _context.next = 31;
                break;
              }
              _context.next = 29;
              return deserializeContent(response, "text");
            case 29:
              errorMessage = _context.sent;
              throw new HttpError(errorMessage || response.statusText, response.status);
            case 31:
              content = deserializeContent(response, request.responseType);
              _context.next = 34;
              return content;
            case 34:
              payload = _context.sent;
              return _context.abrupt("return", new HttpResponse(response.status, response.statusText, payload));
            case 36:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[10, 16, 22, 26]]);
      }));
      function send(_x) {
        return _send.apply(this, arguments);
      }
      return send;
    }()
  }, {
    key: "getCookieString",
    value: function getCookieString(url) {
      var cookies = "";
      if (Platform.isNode && this._jar) {
        // @ts-ignore: unused variable
        this._jar.getCookies(url, function (e, c) {
          return cookies = c.join("; ");
        });
      }
      return cookies;
    }
  }]);
  return FetchHttpClient;
}(HttpClient);
function deserializeContent(response, responseType) {
  var content;
  switch (responseType) {
    case "arraybuffer":
      content = response.arrayBuffer();
      break;
    case "text":
      content = response.text();
      break;
    case "blob":
    case "document":
    case "json":
      throw new Error("".concat(responseType, " is not supported."));
    default:
      content = response.text();
      break;
  }
  return content;
}